import { useQuery } from '@tanstack/react-query';

import { getClientInit } from '~/services/PromoService';

export const clientInitQueryKeys = {
  all: ['client-init'] as const,
  detail: (query: unknown) => [...clientInitQueryKeys.all, query] as const,
};

type Params = {
  query: Parameters<typeof getClientInit>[0];
  enabled?: boolean;
};

export function useGetClientInit({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: clientInitQueryKeys.detail(query),
    queryFn: async ({ signal }) => {
      const response = await getClientInit(query, { signal });
      return {
        channelMarkupConfig: {
          channelMarkupListV1: [],
          channelMarkupListV2: response.result.config.channelMarkupInitConfig.channelMarkupListV2,
          globalOfferIdBlockList: response.result.config.channelMarkupInitConfig.globalOfferIdBlockList,
        },
      };
    },
    enabled,
  });
}
